import React, { useEffect } from 'react'
import './Style.css'
import Logo from '../Images/logo.png'
import { FaAngleRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className='navB container'>
        <div className='logo'>
          <a href='/home'><img src={Logo} alt="" /></a>
        </div>
        <div className='BtnNav'><button onClick={() => navigate("/blog")}>Blog</button></div>
        <div className='BtnNav'>
          <button onClick={() => navigate("/contact")}>
            Contact Us <FaAngleRight style={{ marginTop: '4px' }} />
          </button>
        </div>
      </div>
    </>
  )
}

export default Navbar